// @flow
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import * as React from 'react';
import { useState } from 'react';
import type { Exhibition } from "../../../types/exhibition/types";
import { Link } from "react-router-dom";
import { ROUTE_PAGE_EXHIBITION } from "../../../routers/routes";
import { getRouteUrl } from "../../../helpers/getRouteUrl";
import { CardActions, CardMedia } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EXHIBITION } from "../../../locales/components/namespaces";
import Paper from "@mui/material/Paper";
import { IMAGE_LOGO } from "../../../assets/images";
import { useMultilingualText } from "../../../hooks/useMultilingualText";

type Props = {
	exhibition: Exhibition
}

const ExhibitionPreviewHorizontal = (props: Props) => {
	const { t } = useTranslation(EXHIBITION)
	const { exhibition: { id, image } } = props
	const [hideImage, setHideImage] = useState(false)
	const defaultImage = useMultilingualText(IMAGE_LOGO)
	return (
		<Paper
			elevation={4}
			sx={{
				borderRadius: '12px',
				overflow: "hidden",
				position: "relative",
				maxWidth:'1042px',
				margin: "auto",
				display: "block",
				boxShadow: 'none'
			}}
		>
			<Card>
				<CardMedia
					sx={{
						width: "100%",
						height: "auto",
						py: !(!hideImage && image) ? 8 : 0,
						px: !(!hideImage && image) ? 12 : 0,
					}}
					onError={() => {
						setHideImage(true)
					}}
					component="img"
					image={(!hideImage && image) ? image : defaultImage}
					alt="exhibition logo"
				/>
				<CardActions sx={{ p: '34px' }}>
					<Button
						sx={{ width: '100%' }}
						variant={"contained"}
						component={Link}
						size={"large"}
						color={"highlight"}
						to={getRouteUrl(ROUTE_PAGE_EXHIBITION, {
							id: id
						})}
					>{t('read_more')}</Button>
				</CardActions>
			</Card>
		</Paper>
	)
}

export default ExhibitionPreviewHorizontal;